import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceComponent } from './invoice.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  DropdownModule,
  OpsNumberDirective,
  ActionMenuComponent,
  ActionMenuDirective,
} from '@ops/components';
import { OpsCalendarComponent } from '@ops/storybook';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    OpsCalendarComponent,
    DropdownModule,
    OpsNumberDirective,
    ActionMenuComponent,
    ActionMenuDirective,
  ],
  exports: [InvoiceComponent],
  declarations: [InvoiceComponent],
})
export class InvoiceModule {}
